export const API_ENDPOINTS = {
  // Authentication
  LOGIN: '/api/nota/auth/login',
  REGISTER: '/api/nota/auth/register',
  VERIFY_EMAIL: '/api/nota/auth/verify-email',
  RESEND_OTP: '/api/nota/auth/resend-otp',
  LOGOUT: '/api/nota/auth/logout',
  ME: '/api/nota/auth/me',
  REFRESH: '/api/nota/auth/refresh',
  FORGOT_PASSWORD: '/api/nota/auth/forgot-password',
  RESET_PASSWORD: '/api/nota/auth/reset-password',
  UPDATE_PROFILE: '/api/nota/auth/profile',
  CHANGE_PASSWORD: '/api/nota/auth/password',

  // Public endpoints
  CONTACT: '/api/nota/public/contact',
  CONSULTATION: '/api/nota/public/consultation',
  NEWSLETTER: '/api/nota/public/newsletter',
  COUNTRIES: '/api/nota/public/countries',
  UNIVERSITIES: '/api/nota/public/universities',
  EMPLOYERS: '/api/nota/public/employers',

  // Study endpoints
  STUDY_DASHBOARD: '/api/nota/study/dashboard',
  STUDY_APPLICATIONS: '/api/nota/study/applications',
  STUDY_APPLICATION: '/api/nota/study/application',
  STUDY_DOCUMENTS: '/api/nota/study/documents',
  STUDY_DOCUMENT: '/api/nota/study/document',
  STUDY_CONSULTATIONS: '/api/nota/study/consultations',
  STUDY_CONSULTATION: '/api/nota/study/consultation',
  STUDY_MESSAGES: '/api/nota/study/messages',
  STUDY_MESSAGE: '/api/nota/study/message',

  // Work endpoints
  WORK_DASHBOARD: '/api/nota/work/dashboard',
  WORK_APPLICATIONS: '/api/nota/work/applications',
  WORK_APPLICATION: '/api/nota/work/application',
  WORK_DOCUMENTS: '/api/nota/work/documents',
  WORK_DOCUMENT: '/api/nota/work/document',
  WORK_INTERVIEWS: '/api/nota/work/interviews',
  WORK_CONSULTATIONS: '/api/nota/work/consultations',
  WORK_CONSULTATION: '/api/nota/work/consultation',
  WORK_MESSAGES: '/api/nota/work/messages',
  WORK_MESSAGE: '/api/nota/work/message',

  // Admin endpoints
  ADMIN_DASHBOARD: '/api/nota/admin/dashboard',
  ADMIN_USERS: '/api/nota/admin/users',
  ADMIN_USER: '/api/nota/admin/user',
  ADMIN_APPLICATIONS: '/api/nota/admin/applications',
  ADMIN_APPLICATION: '/api/nota/admin/application',
  ADMIN_CONSULTATIONS: '/api/nota/admin/consultations',
  ADMIN_CONSULTATION: '/api/nota/admin/consultation',
  ADMIN_CONTACTS: '/api/nota/admin/contacts',
  ADMIN_MESSAGES: '/api/nota/admin/messages',
  ADMIN_MESSAGE: '/api/nota/admin/message',
  ADMIN_DOCUMENTS: '/api/nota/admin/documents',
  ADMIN_STATS: '/api/nota/admin/stats',
};
